import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { FilterParameter, QueryParamsService } from 'common';
import { ClientData } from '../../../auth/client/client.data';
import { UserQueryResult, UserFilters, UserQueryParams } from '../user.model';
import { UserFilterService } from '../user-filter.service';
import { UserListFilterDialogComponent } from '../user-list-filter-dialog/user-list-filter-dialog.component';
import { routerTransition } from '../../../shared/animations/router.animations';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'ifb-user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.scss'],
    animations: routerTransition,
    standalone: false
})
export class UserListComponent implements OnInit {

  filters: UserFilters;
  activeFilters: FilterParameter[] = [];
  queryParams: UserQueryParams;

  constructor(private route: ActivatedRoute,
    private _userFilterService: UserFilterService,
    private dialog: MatDialog,
    private queryParamsService: QueryParamsService) {
  }

  data: UserListComponentData;

  ngOnInit() {
  this.route.data.pipe(untilDestroyed(this)).subscribe((it: UserListComponentData) => this.data = it);
  this.route.queryParams.pipe(untilDestroyed(this)).subscribe(it => {
      this.queryParams = new UserQueryParams(this.queryParamsService.init(it));
      this.activeFilters = this._userFilterService.addFilterParameters(this.queryParams);
    });

    this.filters = new UserFilters(this.queryParams);
    this.paginator.pageSize = this.queryParams.limit;
    this.paginator.pageIndex =  this.queryParams.skip / this.queryParams.limit;
  }

  activeFilterRemoved(activefilters: FilterParameter[]): void {
    if (!activefilters.length) return;
    activefilters.forEach(item => {
      this.filters.remove(item.id);
      this._userFilterService.filter(this.filters);
    });
  }

  filterDialog() {
    UserListFilterDialogComponent.show(this.dialog, new UserFilters(this.queryParams), this.data.clients)
      .subscribe(result => {
        if (result) {
          this.filters = result;
          this.paginator.firstPage();
          this._userFilterService.filter(result);
        }
      });
  }

  sortData(sort: Sort) {
    this._userFilterService.filter(this.filters, this.paginator, this.sort);
  }

  setPage(event: PageEvent) {
    this._userFilterService.filter(this.filters, this.paginator, this.sort);
  }

  @ViewChild(MatPaginator, { static: true })
  paginator: MatPaginator;

  @ViewChild(MatSort)
  sort: MatSort;

  tableColumns: string[] = [
    'clientName',
    'username',
    'externalId',
    'firstName',
    'middleName',
    'lastName',
    'lastLoginDate_IP',
    'status',
    'actions'
  ];

}

export interface UserListComponentData {
  userQueryResult: UserQueryResult;
  clients: ClientData[];
}
